<template>
  <div class="outer-box" >
    <h4>Disable SaaS Mode from a single location.</h4>

    <div class="inner-box" style="text-align: left; width: 600px;">
      <!-- <div>1. Disable SaaS Mode for a single Location:</div> -->
      <b-alert show variant="danger">
        <b>Before disable SaaS, ask agency owner to do two things:</b>
        <br/>
        1. Reconcile the wallet balance with the location
        <br/>
        2. Cancel any saas subscriptions that might be running
        <br />
        3. <b>This step is irreversible</b>
      </b-alert>
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />


      <button class="btn btn-danger mt-4" @click="disableSaas">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Disable</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {

  data() {
    return {
      locationId: '',
      processing: false,
      response: null
    };
  },
  methods: {
    disableSaas(){
      this.processing = true
      SaasService.disableSaasForLocation(this.locationId)
        .then(response => {
          this.response = response.data
        })
        .catch(error => {
          this.response = error.message
        })
        .finally(() => {
            this.processing = false;
        });
    },
  }
}
</script>

<style>
</style>
